module.exports = __webpack_public_path__ + "static/media/Somi-profile-icon.4808452c.png";